export default __webpack_public_path__ + "static/media/mychoko-recom.fcbd8a2c.png";